import { useButtonTexts, useTileTexts } from "Store/texts/hooks";
import { buttonNextTrackId, buttonTrackId } from "Utils/analytics";

import { activateStartStep } from "Store/steps/stepsSlice";
import { TextLanguage } from "Store/texts/interfaces";
import { isAuthenticated } from "Utils/KeycloakWrapper";
import React from "react";
import { useDispatch } from "react-redux";
import { useBankIdLoginHandler } from "./bankIdLoginHooks";
import { StyledBankIdButton } from "./styled";

export const AdviceLoginForm = (): React.ReactElement => {
  const dispatch = useDispatch();
  const handleBankIdLogin = useBankIdLoginHandler();
  const [{ loginTile }, lang] = useTileTexts();
  const [{ next }] = useButtonTexts();

  const setStartStepActive = (): void => {
    dispatch(activateStartStep());
  };

  return isAuthenticated() ? (
    <StyledBankIdButton
      id="button-next"
      trackId={buttonNextTrackId(next[TextLanguage.ENGLISH])}
      onClick={setStartStepActive}
    >
      {next[lang]}
    </StyledBankIdButton>
  ) : (
    <StyledBankIdButton
      trackId={buttonTrackId(
        loginTile.adviceLogin.adviceLoginButton[TextLanguage.ENGLISH],
      )}
      onClick={() => handleBankIdLogin()}
    >
      {loginTile.adviceLogin.adviceLoginButton[lang]}
    </StyledBankIdButton>
  );
};
